import KudosLogo from '@assets/images/KudosLogo.svg'
import MediaImage from '@components/MediaImage'
import { colors } from '@globals/themes/defaultTheme'
import Box from '@mui/material/Box'
import { useT } from '@transifex/react'

const PageKudosTitleImage: React.FC = () => {
  const t = useT()
  return (
    <Box mt={1} height={32}>
      <MediaImage imgSrc={KudosLogo} alt={t('Kudos logo')} backgroundColor={colors.white} />
    </Box>
  )
}

export default PageKudosTitleImage
